import { Map, Record, Set } from "immutable";

import syncApplications from "../../../../constants/syncApplications";
import createFromJS from "../../../createFromJS";

export const SyncSettingsRecord = Record({
  enabled: false,
  app: syncApplications.NONE,
  path: null,
  // Which ID in the tree represents the narrative?
  narrativeFolderId: null,
  entityFolders: Map(),
  useKeywordsForRelationships: true,
  keywordTypes: Set(),
  fields: Map()
});

const data = {
  objects: {
    keywordTypes: "Set"
  },
  collections: {
    fields: "SyncFieldSettingsRecord",
    entityFolders: "SyncEntityFolderSettingsRecord"
  }
};

createFromJS.registerCallback("SyncSettingsRecord", createFromJS.createNestedCallback(SyncSettingsRecord, data));
